import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";
import scrollama from "scrollama";
import classNames from "classnames";
import debounce from "lodash/debounce";
import clamp from "lodash/clamp";
import Item from "./components/Item";
import { doesClientSupportScrollWithOptions } from "./browserFeatureDetection"; // whatwg-url support

import "core-js-pure/features/url";

var PageNavInner = /*#__PURE__*/function (_React$Component) {
  _inherits(PageNavInner, _React$Component);

  var _super = _createSuper(PageNavInner);

  function PageNavInner() {
    var _this;

    _classCallCheck(this, PageNavInner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      currentItemIndex: 0,
      items: [],
      expanded: false
    });

    _defineProperty(_assertThisInitialized(_this), "scrollOffsetTolerance", 10);

    _defineProperty(_assertThisInitialized(_this), "resizeDebounceTimeout", 200);

    _defineProperty(_assertThisInitialized(_this), "resizeScrollSpyDebounced", void 0);

    _defineProperty(_assertThisInitialized(_this), "scroller", void 0);

    _defineProperty(_assertThisInitialized(_this), "ref", void 0);

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory("PageNavInner"));

    _defineProperty(_assertThisInitialized(_this), "clientSupportsScrollWithOptions", void 0);

    _defineProperty(_assertThisInitialized(_this), "setupScrollSpy", function () {
      _this.resizeScrollSpyDebounced = debounce(_this.resizeScrollSpy, _this.resizeDebounceTimeout);
      window.addEventListener("resize", _this.resizeScrollSpyDebounced); // setup the instance, pass callback functions

      return scrollama().setup({
        step: ".".concat(getClassNameFactory("PageNavAnchor")()),
        offset: _this.scrollSpyOffset
      }).onStepEnter(_this.handleStepChange).onStepExit(_this.handleStepChange);
    });

    _defineProperty(_assertThisInitialized(_this), "resizeScrollSpy", function () {
      _this.scroller.offsetTrigger(_this.scrollSpyOffset);

      _this.scroller.resize();
    });

    _defineProperty(_assertThisInitialized(_this), "handleStepChange", function (_ref) {
      var direction = _ref.direction,
          index = _ref.index,
          element = _ref.element;
      var items = _this.state.items;
      var maxItemsIndex = items.length - 1;
      var minItemsIndex = 0;
      /**
       * ignore other anchor that is not registered as `state.items` with a `PageNav.Item` child
       *
       * ex: this may include a CTA action within `PageNav` such as a `Contact Us` button
       *    which also has a `PageNav.Anchor` but is not registered as a `PageNav.Item`
       */

      var isNotPageNavItem = !_this.state.items.find(function (item) {
        return item.href.replace("#", "") === element.id;
      });

      if (isNotPageNavItem) {
        return;
      }

      var currentItemIndex = index; // if we're scrolling up, and pass an anchor assume we're entering the previous section

      if (direction === "up") {
        currentItemIndex--;
      }

      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          // `clamp` returns a the index limited by a min and max
          currentItemIndex: clamp(currentItemIndex, minItemsIndex, maxItemsIndex)
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "scrollTo", function (top) {
      if (_this.clientSupportsScrollWithOptions) {
        window.scrollTo({
          top: top,
          behavior: "smooth"
        });
      } else {
        window.scrollTo(0, top);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      // document.activeElement is IE11 fallback
      var relatedTarget = event.relatedTarget || document.activeElement; // This prevents blurring when the next target is within the PageNav.

      if (_this.ref && relatedTarget && _this.ref.contains(relatedTarget)) {
        return;
      }

      _this.setState({
        expanded: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      return _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          expanded: !state.expanded
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemClick", function (event) {
      _this.setState({
        expanded: false
      });

      var targetAnchorElem = event.currentTarget;
      var targetAnchorURL = new URL(targetAnchorElem.href);
      var currentLocationURL = new URL(window.location.href);
      var isTargetHash = Boolean(targetAnchorURL.hash);
      var isSameOrigin = targetAnchorURL.origin === currentLocationURL.origin;
      var shouldOverrideAnchorDefaultBehaviour = isTargetHash && isSameOrigin;

      if (!shouldOverrideAnchorDefaultBehaviour) {
        /**
         * use `document.location.assign` so we can spy on this function for testing
         */
        document.location.assign(targetAnchorURL.href);
        return;
      }

      event.preventDefault();

      var targetAnchorElemTop = _this.getsAnchorPointedPageAreaTopPosition(targetAnchorURL.hash);

      if (!targetAnchorElemTop) {
        return;
      }

      var scrollToTop = targetAnchorElemTop - _this.ref.offsetHeight;

      _this.emulateAnchorAction(scrollToTop, targetAnchorElem);
    });

    return _this;
  }

  _createClass(PageNavInner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var expanded = this.state.expanded;
      var className = this.getClassName({
        states: classNames({
          expanded: expanded
        })
      });
      var pageInnerElement = document.querySelector(className);
      this.clientSupportsScrollWithOptions = doesClientSupportScrollWithOptions();

      if (pageInnerElement) {
        pageInnerElement.addEventListener("keyup", function (e) {
          if (e.key === "Enter") {
            var parentElement = e.target;

            if (parentElement) {
              var headingElement = parentElement.querySelector("h2");

              if (headingElement) {
                headingElement.style.zIndex = "-1";
                headingElement.focus();
              }
            }
          }
        });
      }

      if (this.props.spy) {
        this.scroller = this.setupScrollSpy();
      }

      this.setState(function (state, props) {
        var _PageNavInner$getCurr = PageNavInner.getCurrentItems(props.children),
            items = _PageNavInner$getCurr.items,
            currentItemIndex = _PageNavInner$getCurr.currentItemIndex;

        return _objectSpread(_objectSpread({}, state), {}, {
          currentItemIndex: currentItemIndex,
          items: items,
          expanded: false
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.scroller) {
        this.scroller.destroy();
        window.removeEventListener("resize", this.resizeScrollSpyDebounced);
      }
    }
    /**
     * `setupScrollSpy` creates a new `scrollama` instance and registers the window `resize` event
     *  https://github.com/russellgoldenberg/scrollama
     */

  }, {
    key: "scrollSpyOffset",
    get:
    /**
     * returns the computed `scrollOffset` value
     */
    function get() {
      if (!this.ref) {
        return 0;
      }

      var scrollOffset = (this.ref.clientHeight + this.scrollOffsetTolerance) / window.innerHeight;
      return scrollOffset;
    }
    /**
     * `resizeScrollSpy` is registered on window resize events
     *  it calls `scrollamas` resize function and recomputes the `scrollSpyOffset`
     */

  }, {
    key: "emulateAnchorAction",
    value: function emulateAnchorAction(scrollToTop, targetAnchorElem) {
      this.scrollTo(scrollToTop);
      history.pushState(null, "", targetAnchorElem.href); // looks like anchor is being focused after scrolling, needs to blur it as there are
      // some styles related to that behavior

      setTimeout(function () {
        targetAnchorElem.blur();
      }, 0);
    }
    /**
     * `getsAnchorPointedPageAreaTopPosition` returns the top coordinates of a target element
     *  used in `handleItemClick`
     */

  }, {
    key: "getsAnchorPointedPageAreaTopPosition",
    value: function getsAnchorPointedPageAreaTopPosition(targetHash) {
      var targetAnchorElem = document.querySelector(targetHash);

      if (!targetAnchorElem) {
        return;
      }

      var targetAnchorElemTop = targetAnchorElem.getBoundingClientRect().top + window.pageYOffset;
      return targetAnchorElemTop;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          items = _this$state.items,
          currentItemIndex = _this$state.currentItemIndex,
          expanded = _this$state.expanded;
      var currentItem = items[currentItemIndex];
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          states: classNames({
            expanded: expanded
          })
        }),
        ref: function ref(_ref2) {
          if (_ref2) {
            _this2.ref = _ref2;
          }
        },
        "data-rehydratable": getRehydratableName(PageNavInner.displayName),
        "data-spy": this.props.spy ? JSON.stringify(this.props.spy) : null,
        "data-link-style": this.props.linkStyle
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "container"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "header"
        })
      }, /*#__PURE__*/React.createElement("button", {
        className: this.getClassName({
          descendantName: "currentItem"
        }),
        onClick: this.handleClick,
        onBlur: this.handleBlur,
        "aria-expanded": expanded
      }, /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "currentItemTitle"
        })
      }, currentItem.title), /*#__PURE__*/React.createElement("span", {
        className: this.getClassName({
          descendantName: "currentItemIcon"
        })
      }, expanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, {
        width: 16
      }) : /*#__PURE__*/React.createElement(ChevronDownIcon, {
        width: 16
      }))), this.props.actions && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "actions"
        })
      }, this.props.actions), this.props.share && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "share"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "shareInner"
        })
      }, this.props.share))), /*#__PURE__*/React.createElement("ol", {
        className: this.getClassName({
          descendantName: "items"
        }),
        onBlur: this.handleBlur
      }, items.map(function (item, i) {
        return /*#__PURE__*/React.createElement(Item, _extends({
          key: i
        }, item, {
          active: _this2.props.linkStyle === "jump-links" ? currentItemIndex === i : item.active,
          onItemClick: _this2.handleItemClick
        }));
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var _PageNavInner$getCurr2 = PageNavInner.getCurrentItems(nextProps.children),
          items = _PageNavInner$getCurr2.items;

      return _objectSpread(_objectSpread({}, state), {}, {
        items: items
      });
    }
  }]);

  return PageNavInner;
}(React.Component);

_defineProperty(PageNavInner, "displayName", "PageNavInner");

_defineProperty(PageNavInner, "defaultProps", {
  sticky: true,
  spy: true
});

_defineProperty(PageNavInner, "getCurrentItems", function (children) {
  return React.Children.toArray(children).reduce(function (itemState, item) {
    var type = item.type,
        props = item.props;

    if (type === Item) {
      itemState.items.push(item.props);

      if (props.active) {
        itemState.currentItemIndex = itemState.items.length - 1;
      }
    }

    if (type === React.Fragment) {
      return PageNavInner.getCurrentItems(item.props.children);
    }

    return itemState;
  }, {
    items: [],
    currentItemIndex: 0
  });
});

export default PageNavInner;